'use client';

import { useRouter } from 'next/navigation';
import { PropsWithChildren, useCallback } from 'react';
import PullToRefresh from 'react-simple-pull-to-refresh';

export const PullToRefreshProvider = ({ children }: PropsWithChildren) => {
  const router = useRouter();

  const handleRefresh = useCallback(async () => {
    await new Promise((resolve) => setTimeout(resolve, 500));
    router?.refresh();
  }, [router]);

  return (
    <PullToRefresh
      className={'w-full h-full'}
      onRefresh={handleRefresh}
      fetchMoreThreshold={100}
      pullDownThreshold={67}
      maxPullDownDistance={95}
      resistance={1}
      pullingContent=""
    >
      {children}
    </PullToRefresh>
  );
};
